export default __webpack_public_path__ + "static/1-90063c4637b9ebcb15d1e25df4e159ee.jpeg";